import { themeColors, themeMode } from '@juvare/common-web-ui/JuvareTheme';
import React from 'react';
export const AltchaWidget = ({ onVerified, labels, challengeProp }) => {
    const altchaRef = React.useRef(null);
    React.useEffect(() => {
        const handleVerified = (event) => {
            const detail = event.detail;
            onVerified(detail.payload);
        };
        const altchaElement = altchaRef.current;
        altchaElement === null || altchaElement === void 0 ? void 0 : altchaElement.addEventListener('verified', handleVerified);
        return () => {
            altchaElement === null || altchaElement === void 0 ? void 0 : altchaElement.removeEventListener('verified', handleVerified);
        };
    }, [onVerified]);
    return React.createElement('altcha-widget', Object.assign({ ref: altchaRef, theme: themeMode === 'light' ? 'light' : 'dark', hidelogo: true, hidefooter: true, style: {
            '--altcha-border-width': '1px',
            '--altcha-border-radius': '4px',
            '--altcha-color-base': themeColors.surface.primary,
            '--altcha-color-border': themeColors.border.main,
            '--altcha-color-text': themeColors.text.main,
            '--altcha-color-border-focus': themeColors.border.bold,
            '--altcha-color-error-text': themeColors.accent.red.bold,
            '--altcha-color-footer-bg': themeColors.surface.secondary,
            '--altcha-max-width': '260px',
        }, strings: labels ? JSON.stringify(labels) : undefined }, challengeProp));
};
